<template>
  <div>
    <v-layout wrap style="background-color:#F6F6F6;height:100vh">
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12 md4 text-left style="backgroung-color:#fff">
            <v-card flat tile style="width:100%;" color="#fff">
              <v-layout wrap justify-start>
                <v-flex xs12 md4></v-flex>
                <v-flex xs12 md8>
                  <SideBar v-if="loadData" v-bind:userData="userData" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 md8>
            <AccountInfo v-if="loadData" v-bind:userData="userData" @stepper="winStepper" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import SideBar from "./sideBar";
import AccountInfo from "./accountInfo";
export default {
  components: {
    SideBar,
    AccountInfo,
  },
  data() {
    return {
      loadData: false,
      userData: {},
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userData = response.data.data;
            this.loadData = true;
            if (this.userData.dob)
              this.userData.dob = new Date(this.userData.dob)
                .toISOString()
                .substr(0, 10);
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(windowData) {
      this.userData = windowData.userData;
      if (windowData.updateData) this.getData();
    },
  },
};
</script>